var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.5 35.8",
    style: {
      enableBackground: "new 0 0 39.5 35.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M38.9,16.9L20.5,0.6c-0.5-0.4-1.2-0.4-1.6,0L0.7,16.9c-0.3,0.2-0.5,0.6-0.5,0.9c0,0.7,0.5,1.2,1.2,1.2h4.3v15.4 c0,0.7,0.5,1.2,1.2,1.2h9V24.5h7.4v11.1h9.2c0.7,0,1.2-0.5,1.2-1.2V19.1l4.3,0c0.3,0,0.7-0.1,0.9-0.4c0.2-0.2,0.3-0.6,0.3-0.9 S39.1,17.2,38.9,16.9z M24.4,22.2H15c-0.7,0-1.3,0.6-1.3,1.3v9.7H8.2V17.9c0-0.7-0.5-1.2-1.2-1.2H4.7l15-13.5l15.2,13.5h-2.3 c-0.7,0-1.2,0.5-1.2,1.2v15.4h-5.7v-9.7C25.7,22.8,25.1,22.2,24.4,22.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.7143e23f.svg";
export { ForwardRef as ReactComponent };